import { SVGProps } from 'react';

export default function Location13(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="timeline-layout--svg--icon"
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6531 6.87438C14.7984 7.01986 14.8801 7.21707 14.8801 7.42268C14.8801 7.6283 14.7984 7.8255 14.6531 7.97099L11.0323 11.5919C10.8868 11.7372 10.6896 11.8188 10.484 11.8188C10.2783 11.8188 10.0811 11.7372 9.93566 11.5919L7.86658 9.52279C7.79035 9.45176 7.72921 9.3661 7.6868 9.27092C7.64439 9.17574 7.62159 9.073 7.61975 8.96882C7.61791 8.86464 7.63708 8.76115 7.6761 8.66454C7.71512 8.56793 7.77321 8.48016 7.84689 8.40649C7.92056 8.33281 8.00833 8.27472 8.10494 8.2357C8.20155 8.19668 8.30504 8.17751 8.40922 8.17935C8.5134 8.18119 8.61614 8.20399 8.71132 8.2464C8.8065 8.28881 8.89216 8.34995 8.96319 8.42618L10.484 9.94695L13.5565 6.87438C13.702 6.72907 13.8992 6.64746 14.1048 6.64746C14.3105 6.64746 14.5077 6.72907 14.6531 6.87438Z"
        fill={props.fill || 'black'}
        stroke={props.fill || 'black'}
        strokeWidth="0.124144"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.23148 8.31015C2.4083 6.16535 3.38522 4.16548 4.96825 2.70759C6.55129 1.2497 8.62467 0.440423 10.7768 0.44043H11.2237C13.3757 0.440423 15.4491 1.2497 17.0322 2.70759C18.6152 4.16548 19.5921 6.16535 19.7689 8.31015C19.9657 10.6992 19.2277 13.0714 17.7102 14.9271L12.7517 20.9905C12.5395 21.25 12.2723 21.4591 11.9694 21.6027C11.6665 21.7462 11.3354 21.8207 11.0002 21.8207C10.665 21.8207 10.334 21.7462 10.0311 21.6027C9.72816 21.4591 9.46094 21.25 9.24874 20.9905L4.2902 14.9271C2.77266 13.0714 2.03459 10.6992 2.23148 8.31015ZM10.7768 1.99224C9.0144 1.9925 7.31657 2.6554 6.02028 3.84935C4.72399 5.0433 3.92401 6.68101 3.77914 8.4374C3.61527 10.4256 4.22946 12.3999 5.49234 13.9442L10.4509 20.0087C10.5175 20.0903 10.6015 20.156 10.6967 20.2012C10.7919 20.2463 10.8959 20.2697 11.0012 20.2697C11.1066 20.2697 11.2106 20.2463 11.3058 20.2012C11.401 20.156 11.485 20.0903 11.5516 20.0087L16.5102 13.9442C17.7723 12.3996 18.3857 10.4254 18.2213 8.4374C18.0764 6.68084 17.2763 5.04298 15.9798 3.849C14.6832 2.65503 12.9852 1.99224 11.2226 1.99224H10.7757H10.7768Z"
        fill={props.fill || 'black'}
        stroke={props.fill || 'black'}
        strokeWidth="0.124144"
      />
    </svg>
  );
}
